import { CircularProgress } from "@suraasa/placebo-ui"
import { ToolType } from "api/resources/aiTools/types"
import { getToolName } from "features/AItools/helper"

import Heading from "../../Heading"
import ContentActions from "../GenerationOutput/Export/ContentActions"
import QuizOutput from "../GenerationOutput/QuizOutput"
import ProForm from "./ProForm"
import { useQuiz } from "./useQuiz"

const QuizGenerator = ({
  toggleHistorySideBar,
}: {
  toggleHistorySideBar: (state: boolean) => void
}) => {
  const {
    currentResponseId,
    setCurrentResponseId,
    pageLoading,
    onBack,
    promptDataId,
    ...quizContext
  } = useQuiz()

  if (promptDataId && pageLoading) {
    return (
      <div className="grid place-items-center p-4">
        <CircularProgress />
      </div>
    )
  }

  if (currentResponseId) {
    return (
      <>
        <ContentActions
          onBack={onBack}
          currentResponseId={currentResponseId}
          toolType={ToolType.quiz}
          title={quizContext.overviewData?.title}
          hideExportOutputButton={
            quizContext.isLoading ||
            quizContext.isError ||
            currentResponseId === undefined
          }
          toggleHistorySideBar={toggleHistorySideBar}
        />

        <QuizOutput
          {...quizContext}
          currentResponseId={currentResponseId}
          setCurrentResponseId={setCurrentResponseId}
          onBack={onBack}
        />
      </>
    )
  }

  return (
    <>
      <Heading
        title={`${getToolName(ToolType.quiz)} Generator`}
        subtitle="Engage and challenge your students with customised quizzes."
        toggleHistorySideBar={toggleHistorySideBar}
      />
      {/* <TogglePro
        isPro={enableProMode}
        onChange={state => setEnableProMode(state)}
        className="mb-2"
      /> */}
      <ProForm {...quizContext} />
      {/* {enableProMode ? (
        <ProForm {...quizContext} />
      ) : (
        <BasicForm {...quizContext} />
      )} */}
    </>
  )
}

export default QuizGenerator
